<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content v-if="logs.length">
          <md-table
            v-model="logs"
            class="paginated-table table-striped table-hover table-bordered"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                :md-label="$t('common.no_number')"
                class="no-number"
                >{{ logs.indexOf(item) + 1 }}
              </md-table-cell>
              <md-table-cell :md-label="$t('setting.creator')"
                >{{ item.downloader_no_sql.full_name }}
              </md-table-cell>
              <md-table-cell :md-label="$t('common.date')"
                >{{
                  convertDateFromServer(new Date(item.created_at), "date-time")
                }}
              </md-table-cell>
              <md-table-cell :md-label="$t('common.student')"
                >{{ item.student_no_sql.email }}
              </md-table-cell>
              <md-table-cell :md-label="$t('common.description')">
                <a :href="item.link_file" target="_blank">
                  {{ item.student_no_sql.full_name }}
                </a>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <div
            v-if="logs.length < resultTotal"
            class="flex justify-center my-3"
          >
            <a
              class="text-info hover:text-info font-medium"
              @click="loadMore()"
            >
              {{ $t("setting.load_more") }}
            </a>
          </div>
        </md-card-content>
        <div v-else>
          <no-data-found></no-data-found>
        </div>
      </md-card>
    </div>
  </div>
</template>
<script>
import { service_names } from "../../constants/Services";
import { convertDateFromServer } from "../../helpers/datetime-helper";

export default {
  name: "transcript-history",
  data() {
    return {
      convertDateFromServer,
      path: `${service_names.utility}/transcript-history`,
      logs: [],
      page: 1,
      resultTotal: 0
    };
  },
  methods: {
    getLog(page) {
      this.$axios.get(this.path, { limit: 10, page: page }).then(response => {
        this.logs = [...this.logs, ...response.data.data];
        this.resultTotal = response.data.total;
        return this.logs;
      });
    },
    loadMore() {
      this.getLog((this.page += 1));
    }
  },
  created() {
    this.getLog(this.page);
  }
};
</script>
